import { useTranslate } from 'hooks/useTranslate';
import { FC, useMemo } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

const PublishTradingOfferModalHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = usePublishTradingOfferModal();

  const isSellOffer = data.tradingOffer?.type === 'SELL';

  const modalTitle = useMemo(() => {
    if (data.modalActionType === actionTypes.EDIT) return t('EditOffer');
    return isSellOffer
      ? t('ConfirmSellOfferQuestion')
      : t('ConfirmBuyOfferQuestion');
  }, [data.modalActionType, isSellOffer, t]);

  return (
    <Modal.Header>
      <div>
        <h5 className="modal-title">{modalTitle}</h5>
        <p className="text-soft small mb-0">
          {t('OfferVisibleToAllPartners')}
        </p>
      </div>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default PublishTradingOfferModalHeader;
